export default __webpack_public_path__ + "static/media/dashboard.43eacb32.svg";